import { ProviderUtils } from "utils/providerUtils";

export const LOTTECARD_KTX_SERVICE_END_DATE_TEXT = "2026년 7월 31일";

const LOTTECARD_KTX_RESERVATION_END_AT = new Date(
  "2026-07-31T00:00:00+09:00"
).getTime();

export const isLottecardKtxReservationEnded = (now = new Date()) => {
  return (
    ProviderUtils.isLottecard &&
    now.getTime() >= LOTTECARD_KTX_RESERVATION_END_AT
  );
};
